import React from 'react'
import {Lang} from 'yougile-lang'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {CommonProps} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sticker-settings-content'
import {TwSetting} from './containers'

export const FilterByCurrentValueSettingsContent = (props: CommonProps) => {
  const {state, setState} = props
  const toggleFilterByCurrentValue = () =>
    setState(x => ({
      ...x,
      filterByCurrentValue: !(x.filterByCurrentValue ?? true)
    }))

  return (
    <TwSetting>
      <CheckboxNew
        className="py-8"
        value={state.filterByCurrentValue ?? true}
        onChange={toggleFilterByCurrentValue}
        label={Lang.msg.myStickers.filterByCurrentValue}
      />
    </TwSetting>
  )
}
